if (!customElements.get('product-recommendations')) {
  customElements.define(
    'product-recommendations',
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();

        // Conditional logging setup
        const isDev =
          window.location.hostname.includes('myshopify.com') ||
          window.location.hostname === 'localhost';
        // eslint-disable-next-line no-console
        this.log = isDev ? console.log.bind(console) : () => {};
        this.warn = isDev ? console.warn.bind(console) : () => {};
        this.error = isDev ? console.error.bind(console) : () => {};

        if ('requestIdleCallback' in window) {
          requestIdleCallback(this.init.bind(this), { timeout: 1500 });
        } else {
          FoxTheme.Motion.inView(this, this.init.bind(this), { margin: '0px 0px 400px 0px' });
        }
      }

      init() {
        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((responseText) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector('.shopify-section');

            if (sectionInnerHTML === null) return;

            const recommendations = sectionInnerHTML.querySelector('product-recommendations');
            if (recommendations && recommendations.textContent.trim().length) {
              // Use replaceChildren for safer DOM manipulation
              this.replaceChildren(
                ...Array.from(recommendations.children).map((child) => child.cloneNode(true))
              );
            }

            if (recommendations && recommendations.querySelector('.product-card')) {
              this.dispatchEvent(new CustomEvent('recommendations:loaded'));
            } else {
              if (recommendations && recommendations.classList.contains('complementary-products')) {
                const _block = this.closest('.product__block');
                if (_block) _block.remove();
              } else {
                const _section = this.closest('.shopify-section');
                if (_section) _section.remove();
              }
              this.dispatchEvent(new CustomEvent('recommendations:empty'));
            }
          })
          .catch((e) => {
            this.error(e);
          });
      }
    }
  );
}
